import {
  ParameterDto,
  ParameterLimitConstraint,
  ParameterLimits,
  StoreMetaDataDto,
} from 'apis/backendApi';

export enum ParameterName {
  // f6
  ALERT_LOC_LOC_SHORT = 'ALERT_LOC_LOC_SHORT',
  ALERT_OVER_MAX = 'ALERT_OVER_MAX',
  ALERT_UNDER_MIN = 'ALERT_UNDER_MIN',
  ALERT_UNPLANNED_ART = 'ALERT_UNPLANNED_ART',
  SLM_AUTO_INC_RP = 'SLM_AUTO_INC_RP',
  SLM_HIST_DAYS = 'SLM_HIST_DAYS',
  SLM_SPAC_NEED_GREEN = 'SLM_SPAC_NEED_GREEN',
  SLM_SPAC_NEED_YELLOW = 'SLM_SPAC_NEED_YELLOW',
  SLM_SPAC_USE_GREEN = 'SLM_SPAC_USE_GREEN',
  SLM_SPAC_USE_YELLOW = 'SLM_SPAC_USE_YELLOW',
  SLM_DIR_FLOW_GREEN = 'SLM_DIR_FLOW_GREEN',
  SLM_DIR_FLOW_YELLOW = 'SLM_DIR_FLOW_YELLOW',
  SLM_MIN_INDEL_AMOUNT = 'SLM_MIN_INDEL_AMOUNT',
  SLM_WARN_ASSQ_DAYS = 'SLM_WARN_ASSQ_DAYS',
  SLM_WARN_UNPLAN_DAYS = 'SLM_WARN_UNPLAN_DAYS',
  SLM_EXCESSIVE_DAYS = 'SLM_EXCESSIVE_DAYS',
  SLM_EXCESSIVE_LIMIT = 'SLM_EXCESSIVE_LIMIT',
  SLM_NEW_ART_WEEKS = 'SLM_NEW_ART_WEEKS',
  SLM_SLID_START_DAYS = 'SLM_SLID_START_DAYS',
  SMDQ_FORECAST_PERC = 'SMDQ_FORECAST_PERC',
  SMDQ_MUPQ_PERC = 'SMDQ_MUPQ_PERC',
  SMDQ_SSC = 'SMDQ_SSC',

  //hfb
  TURNOVERRANKDTFP = 'turnOverMarkDftp',
  TURNOVERRANKDTFPP = 'highTurnoverMark',
  TURNOVERRANKMIN = 'lowTurnoverMark',

  // art,div & store
  BACKPANEL_VOL_AVG = 'BACKPANEL_VOL_AVG',
  COMM_QTY_LIMIT_DAYS = 'COMM_QTY_LIMIT_DAYS',
  COV_DAYS_DIRECT = 'COV_DAYS_DIRECT',
  COV_DAYS_DTFPP = 'COV_DAYS_DTFPP',
  COV_DAYS_INDIRECT = 'COV_DAYS_INDIRECT',
  DELIVERY_MAX_PARAM = 'DELIVERY_MAX_PARAM',
  DIRECT_DEL_PICKING = 'DIRECT_DEL_PICKING',
  FLEXIBILITY_PCT = 'FLEXIBILITY_PCT',
  HANDSTACK_CAP_FACTOR = 'HANDSTACK_CAP_FACTOR',
  MAX_SAFETY_STOCK_D = 'MAX_SAFETY_STOCK_D',
  MIN_SAFETY_STOCK = 'MIN_SAFETY_STOCK',
  ORDER_FULL_PLT_ONLY = 'ORDER_FULL_PLT_ONLY',
  OVERSTOCK_LIMIT_DAYS = 'OVERSTOCK_LIMIT_DAYS',
  PALLET_ROUND_FACTOR = 'PALLET_ROUND_FACTOR',
  PEAK_DAY_FACTOR_PCT = 'PEAK_DAY_FACTOR_PCT',
  UNIT_LOAD_LIMIT = 'UNIT_LOAD_LIMIT',
  USE_COMM_QTY = 'USE_COMM_QTY',

  // art only
  SMALL_STORE_MINIMUM_DELIVERY_QUANTITY = 'SMALL_STORE_MINIMUM_DELIVERY_QUANTITY',

  // store only
  RANGE_ALLOC_RATIO = 'RANGE_ALLOC_RATIO',
}

export enum AlertName {}

const BOOLEAN_PARAMETERS = [
  ParameterName.ALERT_LOC_LOC_SHORT,
  ParameterName.ALERT_OVER_MAX,
  ParameterName.ALERT_UNDER_MIN,
  ParameterName.ALERT_UNPLANNED_ART,
  ParameterName.DIRECT_DEL_PICKING,
  ParameterName.ORDER_FULL_PLT_ONLY,
  ParameterName.SLM_AUTO_INC_RP,
  ParameterName.USE_COMM_QTY,
];

const DOUBLE_PARAMETERS = [
  ParameterName.BACKPANEL_VOL_AVG,
  ParameterName.HANDSTACK_CAP_FACTOR,
];

const READONLY_PARAMETERS = [
  ParameterName.ALERT_LOC_LOC_SHORT,
  ParameterName.ALERT_OVER_MAX,
  ParameterName.ALERT_UNDER_MIN,
  ParameterName.ALERT_UNPLANNED_ART,
];

const COMPUTED_PARAMETERS = [ParameterName.TURNOVERRANKDTFPP];

const CRITICAL_PARAMETERS = [
  ParameterName.COMM_QTY_LIMIT_DAYS,
  ParameterName.COV_DAYS_DIRECT,
  ParameterName.COV_DAYS_INDIRECT,
  ParameterName.MAX_SAFETY_STOCK_D,
  ParameterName.MIN_SAFETY_STOCK,
  ParameterName.PALLET_ROUND_FACTOR,
];

export const GROUP_PARAMETERS = [
  ParameterName.BACKPANEL_VOL_AVG,
  ParameterName.COMM_QTY_LIMIT_DAYS,
  ParameterName.COV_DAYS_DIRECT,
  ParameterName.COV_DAYS_DTFPP,
  ParameterName.COV_DAYS_INDIRECT,
  ParameterName.DELIVERY_MAX_PARAM,
  ParameterName.DIRECT_DEL_PICKING,
  ParameterName.FLEXIBILITY_PCT,
  ParameterName.HANDSTACK_CAP_FACTOR,
  ParameterName.MAX_SAFETY_STOCK_D,
  ParameterName.MIN_SAFETY_STOCK,
  ParameterName.ORDER_FULL_PLT_ONLY,
  ParameterName.OVERSTOCK_LIMIT_DAYS,
  ParameterName.PALLET_ROUND_FACTOR,
  ParameterName.PEAK_DAY_FACTOR_PCT,
  ParameterName.UNIT_LOAD_LIMIT,
  ParameterName.USE_COMM_QTY,
];

const OPTIONAL_PARAMETERS = [
  ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
];

const RESET_EXCLUDED_PARAMETERS = [
  ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
];

const CLOUD_ONLY_PARAMETERS = [
  ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
  ParameterName.SMDQ_FORECAST_PERC,
  ParameterName.SMDQ_MUPQ_PERC,
  ParameterName.SMDQ_SSC,
];

const SMALL_STORE_ONLY_PARAMETERS = [
  ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
  ParameterName.SMDQ_FORECAST_PERC,
  ParameterName.SMDQ_MUPQ_PERC,
  ParameterName.SMDQ_SSC,
];

const IGNORED_PARAMETERS = [
  ParameterName.SLM_HIST_DAYS,
  ParameterName.SLM_SPAC_NEED_GREEN,
  ParameterName.SLM_SPAC_NEED_YELLOW,
  ParameterName.SLM_SPAC_USE_GREEN,
  ParameterName.SLM_SPAC_USE_YELLOW,
];

const DEFAULT_LIMIT = { min: 0, max: 999 };

export enum ParameterType {
  INTEGER,
  DOUBLE,
  BOOLEAN,
}

export type ParameterMetadata = {
  type: ParameterType;
  isReadonly: boolean;
  isCritical: boolean;
  isComputed: boolean;
  isOptional: boolean;
  isExcludedFromReset: boolean;
};

/**
 * In case of a `string`, the value is a reference to another parameter.
 */
export type ParameterValue = number | boolean | string;

export type Parameter = {
  readonly name: string;
  readonly value: ParameterValue | null;
};

type ParameterValidation = {
  readonly min: ParameterValue;
  readonly max: ParameterValue;
  readonly allowed?: boolean;
  readonly constraints?: ParameterLimitConstraint[];
};

export type ParameterField = Parameter &
  ParameterMetadata &
  ParameterValidation;

export function parameterMetadata(name: string): ParameterMetadata {
  const parameterName: ParameterName = ParameterName[name];
  let type: ParameterType;
  if (BOOLEAN_PARAMETERS.includes(parameterName)) {
    type = ParameterType.BOOLEAN;
  } else if (DOUBLE_PARAMETERS.includes(parameterName)) {
    type = ParameterType.DOUBLE;
  } else {
    type = ParameterType.INTEGER;
  }
  const isReadonly = READONLY_PARAMETERS.includes(parameterName);
  const isCritical = CRITICAL_PARAMETERS.includes(parameterName);
  const isComputed = COMPUTED_PARAMETERS.includes(parameterName);
  const isOptional = OPTIONAL_PARAMETERS.includes(parameterName);
  const isExcludedFromReset = RESET_EXCLUDED_PARAMETERS.includes(parameterName);

  return {
    type,
    isReadonly,
    isCritical,
    isComputed,
    isOptional,
    isExcludedFromReset,
  };
}

export function createParameterFields(
  parameters: ParameterDto[],
  limits: ParameterLimits[],
  storeMeta?: StoreMetaDataDto,
  sortByNameAndType: boolean = true
): ParameterField[] {
  const fields = parameters
    .filter(
      param =>
        !IGNORED_PARAMETERS.includes(ParameterName[param.name]) &&
        !(
          CLOUD_ONLY_PARAMETERS.includes(ParameterName[param.name]) &&
          !storeMeta?.isCloudMaster
        ) &&
        !(
          SMALL_STORE_ONLY_PARAMETERS.includes(ParameterName[param.name]) &&
          // @ts-ignore
          !storeMeta?.isSmallStore
        )
    )
    .map((param): ParameterField => {
      const matchingLimits =
        limits.find(limit => limit.name === param.name) ?? {};
      const {
        min = DEFAULT_LIMIT.min,
        max = DEFAULT_LIMIT.max,
        allowed,
        constraints,
      } = matchingLimits;
      const { name, value } = param;
      const metadata = parameterMetadata(name);
      return {
        name,
        value: value as unknown as ParameterValue,
        ...metadata,
        min: min as unknown as ParameterValue,
        max: max as unknown as ParameterValue,
        allowed,
        constraints,
      };
    });

  const numericFields = fields.filter(
    field =>
      field.type === ParameterType.INTEGER ||
      field.type === ParameterType.DOUBLE
  );
  if (sortByNameAndType) {
    numericFields.sort((a, b) => a.name.localeCompare(b.name));
  }

  const booleanFields = fields.filter(
    field => field.type === ParameterType.BOOLEAN
  );
  if (sortByNameAndType) {
    booleanFields.sort((a, b) => a.name.localeCompare(b.name));
  }

  return [...numericFields, ...booleanFields];
}

export const ARTICLE_NUMBER_PATTERN = /\d{1,8}/;

export type Article = {
  name: string;
  articleNumber: string;
  fields: ParameterField[];
};

export enum GroupFilter {
  DIVISION = 'division',
  SPECIALITY_SHOP = 'speciality_shop',
  HFB = 'hfb',
  RANGE_AREA = 'range_area',
  PRODUCT_AREA = 'product_area',
  SALES_METHOD = 'sales_method',
  SERVICE_CLASS = 'service_class',
}
